// const state = {
//     form: {
//         limit: 50,
//         dateColumn: 'createdDate',
//         status: 'OPEN',
//         client: '',
//         category: null,
//         user: null,
//     },
// };
//
// const mutations = {
//     SET_FORM(state, form) {
//         state.form = form;
//     },
// };
//
// const actions = {
//     saveForm({ commit }, form) {
//         commit('SET_FORM', form);
//     },
// };
//
// const getters = {
//     getForm(state) {
//         return state.form;
//     },
// };
//
// export default {
//     state,
//     mutations,
//     actions,
//     getters,
// };

const state = {
    form: {
        limit: 50,
        dateColumn: 'createdDate',
        status: 'OPEN',
        client: '',
        category: null,
        user: null,
    },
};

const mutations = {
    SET_FORM(state, form) {
        state.form = form;
        // Save to localStorage whenever form is set
        localStorage.setItem('formData', JSON.stringify(form));
    },
};

const actions = {
    loadForm({ commit }) {
        const savedForm = JSON.parse(localStorage.getItem('formData'));
        if (savedForm) {
            commit('SET_FORM', savedForm); // Load the form data from localStorage if it exists
        }
    },
    saveForm({ commit }, form) {
        commit('SET_FORM', form); // Save the form data to Vuex and localStorage
    },
};

const getters = {
    getForm(state) {
        return state.form;
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};

